import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* LEFT: BRAND */}
        <div className="footer-brand">
          <h3>REACH AI</h3>
          <p>
            AI-powered health assistance designed for accessibility,
            awareness, and wellbeing.
          </p>
        </div>

        {/* CENTER: LINKS */}
        <nav className="footer-links">
          <a href="/about">About</a>
          <a href="/contact">Contact</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
        </nav>

        {/* RIGHT: SOCIAL */}
        <div className="footer-social">
  <a
    href="https://facebook.com"
    target="_blank"
    rel="noreferrer"
    aria-label="Facebook"
  >
    <img src="/images/fac.svg.webp" alt="Facebook" />
  </a>

  <a
    href="https://twitter.com"
    target="_blank"
    rel="noreferrer"
    aria-label="Twitter"
  >
    <img src="/images/xtw.avif" alt="Twitter" />
  </a>

  <a
    href="https://instagram.com"
    target="_blank"
    rel="noreferrer"
    aria-label="Instagram"
  >
    <img src="/images/ins.png.webp" alt="Instagram" />
  </a>
</div>


      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        © 2024-2026 REACH AI Health Assistant · All rights reserved
      </div>
    </footer>
  );
}

export default Footer;
